//Dependencies
import React from 'react';

/* NAVBAR */
const Navbar01 = (props) =>
{  
  const { info, height } = props; 

  return(
    <nav 
      className = {`select-none	fixed top-0 flex justify-center items-center bg-white	text-gray-800 w-screen z-[1000] flex border-b border-solid border-black`}
      style = {{height : height}}
    >
      {info &&
        <h1 
          className = "xl:text-3xl text-2xl font-bold font-heading tracking-wider m-0 uppercase" 
        >
        {`${info.info.name} - ${info.info.type}`}
      </h1>
      }
    </nav>
  );
}

export default Navbar01;